import React, { useEffect, useState } from "react";
import { Container, Form } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import InputMask from "react-input-mask";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import './Location.css';
import TopHeader from "../Common/TopHeader";
import { GetApiMethod, PostApiMethod } from "../../core/services/apiService";
import { DisplayToaster, restrictIntialSpace, RevertFormattedPhoneNumber, textValidator, DisplayErrorMessages, formatLocData, checkDisbale } from "../../core/services/sharedService";
import constant from "../../core/constant";
import { CompactPicker } from 'react-color';
import "./Location.css";
import TooltipPositioned from "../Tooltip/TooltipPositioned";
import MultiPMSconnection from "./MultiPMSconnection";
import BusinessHoursCollapsible from "../Common/BusinessHoursCollapsible";
import SearchableSelect from "../Common/SearchableSelect";


const CreateLocation = () => {

    const [searchParams] = useSearchParams();
    const [resultData, setResultData] = useState("");
    const [disable, setDisable] = useState(false);
    const [isLoading, setLoading] = useState<boolean>(false);
    const [fileSize, setFileSize] = useState(false);
    const [fileValidation, setFileValidation] = useState(false);
    const [agentCheck, setAgentCheck] = useState(false);
    const [contact, setContact] = useState('');
    const [callForwardContact, setCallForwardContact] = useState('');
    const [customerContact, setCustomerContact] = useState('');
    const [backGroundColor, setBackGroundColor] = useState<string>('#ffffff');
    const [footerImage, setFooterImage] = React.useState<any>();
    const [kioskHomeScreenLogo, setKioskHomeScreenLogo] = React.useState<any>();
    const { register, handleSubmit, getValues, getFieldState, setValue, resetField, control, formState: { errors }, setError } = useForm<any>();
    const locationUrl = "tenant/location-crud";
    const [customerFacingNumber, setCustomerFacingNumber] = useState<string>();
    const [agentForwardingNumber, setAgentForwardingNumber] = useState<string>();
    const handleColorPickerChange = (color: any) => setBackGroundColor((color && color.hex) ? color.hex : '#ffffff');
    const [callTreeInformationToPlay, setCallTreeInformationToPlay] = React.useState("");
    const [enableCallTree, setEnableCallTree] = React.useState(false);
    const [enableVoiceMail, setEnableVoiceMail] = React.useState(false);
    const [callTreeAudioFile, setCallTreeAudioFile] = React.useState("");
    const [audioFileDelete, setAudioFileDelete] = useState(false);
    const [voicemailAudioFileDelete, setVoicemailAudioFileDelete] = useState(false);
    const [voicemailAudioFile, setVoicemailAudioFile] = React.useState("");
    const navigate = useNavigate();
    const [sendVoiceMailRecording, setSendVoiceMailRecording] = React.useState(true);
    const [mailToAgents, setMailToAgents] = React.useState(false);
    const [additionalEmailAddress, setAdditionalEmailAddress] = React.useState("");
    const [handleEnableDisableEmailToAgentToggle, setHandleEnableDisableEmailToAgentToggle] = useState<boolean>(true);
    const [hummingBirdOrSSM, setHummingBirdOrSSM] = React.useState<string>("false");

    const [timeOffDetails, setTimeOffDetails] = React.useState<any>({
        days: {
            monday: { holiday: false, time: "" },
            tuesday: { holiday: false, time: "" },
            wednesday: { holiday: false, time: "" },
            thursday: { holiday: false, time: "" },
            friday: { holiday: false, time: "" },
            saturday: { holiday: true, time: "" },
            sunday: { holiday: true, time: "" },
        }
    });

    const [callForwardActiveHrs, setCallForwardActiveHrs] = React.useState<any>({
        days: {
            monday: { holiday: false, time: "" },
            tuesday: { holiday: false, time: "" },
            wednesday: { holiday: false, time: "" },
            thursday: { holiday: false, time: "" },
            friday: { holiday: false, time: "" },
            saturday: { holiday: true, time: "" },
            sunday: { holiday: true, time: "" },
        }
    });

    const [agentMappedLocationDetails, setAgentMappedLocationDetails] = useState([{
        name: "",
        id: null
    }]);

    useEffect(() => {
        (async () => {
            const result = await GetApiMethod('tenant/agent-crud');

            const ActiveLocations = result.data.data.filter((items: any) => (items.isActive))
            setResultData(ActiveLocations);

            GetApiMethod(locationUrl).then((res) => {
                let newArray = formatLocData(res.data.data);
                setAgentMappedLocationDetails((prevState) => [...newArray]);
            });
        })();

    }, []);

    const allowedExtensionTypes: any = ["webm", "mp4", "ogv", "mov", "ogg"];
    const allowedImageExtensionTypes: string[] = ["jpg", "png", "jpeg"];
    const allDays = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
    const [assignVals, setAssignVals] = React.useState<any>([]);

    const handleVideotype = (e: any) => {
        let fileExtension = (e.target.files[0]?.name.split(".").at(-1));
        if (fileExtension !== undefined && !allowedExtensionTypes.includes(fileExtension)) {
            setFileValidation(true);
            DisplayToaster("bg-danger", "File type is not supported. Files type must be " + allowedExtensionTypes.join(", "));
            // setDisable(true);
            return false;
        } else {
            setFileValidation(false);
            // setDisable(false);
        }
    }

    const handleImageType = React.useCallback((event: any, fromField = "") => {
        try {
            const fileType = event.target.files[0].name.split(".").at(-1);
            if (!fileType || (fileType && !allowedImageExtensionTypes.includes(fileType))) {
                setFileValidation(true);
                DisplayToaster("bg-danger", "File type is not supported. Files type must be " + allowedExtensionTypes.join(", "));
            } else {
                if (fromField === "kiosk_home_screen_logo") {
                    setKioskHomeScreenLogo(URL.createObjectURL(event.target.files[0]));
                } else {
                    setFooterImage(URL.createObjectURL(event.target.files[0]));
                }
                setFileValidation(false);
            }
        } catch (error) {
            console.log("error while handling image extension", error);
        }

    }, []);

    const handleChange = (e: any) => {
        if (getValues('primary_agent') && (getValues('primary_agent') === getValues('secondary_agent'))) {
            DisplayToaster("bg-danger", "Primary and Secondary agents should be different");
            setAgentCheck(true);
            return false;
        } else {
            setAgentCheck(false);
        }
    }

    const mobileCheck = (num: any) => {
        if ((getValues('contact') && getValues('contact') !== "(") && (getValues('contact') === getValues('call_forward'))) {
            DisplayToaster("bg-danger", "Twilio Number and Agent Unavailable Phone Number should be different.");
            setAgentCheck(true);
        } else {
            setAgentCheck(false);
        }
        const phoneNumber = RevertFormattedPhoneNumber(num.target.value);
        setContact(phoneNumber);
    }

    const call_forward_check = (num: any) => {
        if ((getValues('call_forward') && getValues('call_forward') !== "(") && (getValues('contact') === getValues('call_forward'))) {
            DisplayToaster("bg-danger", "Twilio Number and Agent Unavailable Phone Number should be different.");
            setAgentCheck(true);
        } else {
            setAgentCheck(false);
        }
        const phoneNumber = RevertFormattedPhoneNumber(num.target.value);
        if (num.target.name === "call_forward") {
            setCallForwardContact(phoneNumber);
        }
        else {
            setCustomerContact(phoneNumber);
        }
    }

    const pageDisable = () => {
        setDisable(true);
        setLoading(true);
        document.body.classList.add('screen-disable');
    }

    const pageEnable = () => {
        setDisable(false);
        setLoading(false);
        document.body.classList.remove('screen-disable');
    }

    const handleRegistration = (data: any) => {
        setDisable(true);
        setLoading(true);
        setFileSize(false);
        // setDefState(true);
        const payloadValue = [{ value: data.name, minLength: 4, maxLength: 40, key: 'name' }, { value: data.address, minLength: 4, maxLength: 100, key: 'address' }, { value: data.city, minLength: 2, maxLength: 100, key: 'city' }];
        const validation = textValidator(payloadValue);
        if (validation && validation.validation === true && validation.error) {
            validation.error.forEach(errorCase => {
                setError(errorCase.key, { type: errorCase.type });
            });
            setDisable(false);
            setLoading(false);
            return false;
        }
        if (data.enableVoiceMail && !data.mailToAgents && !data.voiceMailEmail) {
            DisplayToaster("bg-danger", "Any one of the option is required : 1.Additional Voicemail Email Addresses 2.Send Voicemail Email Notifications to Agent");
            setDisable(false);
            setLoading(false);
            return false;
        }

        const form_Data = new FormData();
        form_Data.append('name', data.name?.trim());
        form_Data.append('address', data.address?.trim());
        form_Data.append('activeHrs', JSON.stringify(timeOffDetails));
        form_Data.append('callForwardActiveHrs', JSON.stringify(callForwardActiveHrs));
        data.contact && form_Data.append('contact', RevertFormattedPhoneNumber("1" + data.contact));
        data.call_forward && form_Data.append('call_forward', RevertFormattedPhoneNumber("1" + data.call_forward));
        data.customer_contact && form_Data.append('customer_contact', RevertFormattedPhoneNumber("1" + data.customer_contact));
        form_Data.append('city', data.city?.trim());
        form_Data.append('zipCode', data.zipCode);
        form_Data.append('state', data.state);
        form_Data.append('timeZone', data.timeZone);
        form_Data.append('primary_agent', data.primary_agent);
        form_Data.append('secondary_agent', data.secondary_agent);
        form_Data.append("presentation", data && data.presentation && data.presentation[0] ? data.presentation[0] : null);
        form_Data.append("footer_image", data.kiosk_advertisement[0]);
        form_Data.append("background_color", backGroundColor);
        form_Data.append("enableCallTree", JSON.stringify(enableCallTree));
        form_Data.append("enableVoiceMail", JSON.stringify(enableVoiceMail));
        form_Data.append("callTreeData", JSON.stringify(treeData));
        form_Data.append("callTreeInformationToPlay", data?.callTreeInformationToPlay);
        form_Data.append("voiceMailEmail", data.voiceMailEmail);
        form_Data.append("mailToAgents", data.mailToAgents === undefined ? false : data.mailToAgents);
        form_Data.append("sendRecording", data.sendRecording === undefined ? false : data.sendRecording);
        form_Data.append("voicemailAudio", data.voicemailAudio?.[0]);
        form_Data.append("pms_name", data.pms_name?.trim());
        form_Data.append("application_id", data.application_id?.trim() ?? "");
        form_Data.append("company_id", data.company_id?.trim() ?? "");
        form_Data.append("storageapi_key", data.storageapi_key?.trim() ?? "");
        form_Data.append("hummingBirdOrSSM", hummingBirdOrSSM?.toString());
        form_Data.append("ssm_user_id", data.ssm_user_id?.trim() ?? "");
        form_Data.append("ssm_password", data.ssm_password?.trim() ?? "");
        form_Data.append("ssm_base_url", data.ssm_base_url?.trim() ?? "");
        if (audioFileDelete) {
            form_Data.append("callTreeAudio", "");
        } else {
            form_Data.append("callTreeAudio", data.callTreeAudio?.[0]);
        }
        form_Data.append("kiosk_home_screen_logo", data && data.kiosk_home_screen_logo && data.kiosk_home_screen_logo[0] ? data.kiosk_home_screen_logo[0] : null);

        if (data && data.presentation && data.presentation[0] && data.presentation[0].size > 500000000) {
            DisplayToaster("bg-danger", "Please upload file size below 500mb");
            setFileSize(true);
            setDisable(false);
            setLoading(false);
        } else {
            pageDisable();
            if (!fileValidation && !agentCheck) {
                PostApiMethod(locationUrl, form_Data, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }).then((res: any) => {
                    if (res.data.status === "Success") {
                        pageEnable();
                        navigate(constant.LOCATION_LIST);
                        DisplayToaster("bg-success", "Location " + data.name + " created successfully");
                    }
                }).catch((err: any) => {
                    console.log(err.response);
                    pageEnable();
                    DisplayToaster("bg-danger", DisplayErrorMessages(err) ? DisplayErrorMessages(err) : "Something went wrong!");
                })
            } else {
                pageEnable();
                console.log("please check all the fields");
            }
        }
    };

    const handleHolidayList = (e: any) => {

        if (e.target.checked) {
            setTimeOffDetails((prevState: any) => ({
                days: { ...prevState.days, [e.target.name]: { ...prevState.days.monday, holiday: true, time: "" } }
            }))
        } else {

            (e.target.name.includes("monday")) && setValue('mondayText', e.target.value !== "on" ? e.target.value : null);
            (e.target.name.includes("tuesday")) && setValue('tuesdayText', e.target.value !== "on" ? e.target.value : null);
            (e.target.name.includes("wednesday")) && setValue('wednesdayText', e.target.value !== "on" ? e.target.value : null);
            (e.target.name.includes("thursday")) && setValue('thursdayText', e.target.value !== "on" ? e.target.value : null);
            (e.target.name.includes("friday")) && setValue('fridayText', e.target.value !== "on" ? e.target.value : null);
            (e.target.name.includes("saturday")) && setValue('saturdayText', e.target.value !== "on" ? e.target.value : null);
            (e.target.name.includes("sunday")) && setValue('sundayText', e.target.value !== "on" ? e.target.value : null);

            let name = e.target.name.slice(-4) === "Text" ? e.target.name.slice(0, -4) : e.target.name;
            let convertedTime: string;
            if (e.target.value !== "on") {
                convertedTime = e.target.value.replace(/am/g, "AM").replace(/pm/g, "PM").trim();
            }
            setTimeOffDetails((prevState: any) => ({
                days: { ...prevState.days, [name]: { ...prevState.days.monday, holiday: false, time: e.target.value !== "on" ? convertedTime : "" } }
            }))

        }
    }

    // let [defState, setDefState] = React.useState<boolean>(false);
    // const onError = (errors: any, e: any) => {
    //     setDefState(true);
    //     setDataNotProvided(allDays.filter(x => !assignVals.includes(x)))
    // }


    const [treeData, setTreeData] = React.useState<any>([{
        keyNumber: "",
        targetType: "",
        targetValue: "",
        targetDescription: ""
    }]);

    const addRow = React.useCallback(() => {
        setValue(`keyNumber${treeData?.length}`, null);
        setValue(`targetType${treeData?.length}`, null);
        setValue(`targetValue${treeData?.length}`, null);
        setValue(`targetDescription${treeData?.length}`, null);
        setTreeData([...treeData, {
            keyNumber: "",
            targetType: "",
            targetValue: "",
            targetDescription: ""
        }]);
    }, [treeData])

    const removeField = (e: any, i: number) => {
        let newArray = treeData.filter((item: any, index: number) => (index !== i));
        setValue(`targetType${i}`, null);
        setValue(`keyNumber${i}`, null);
        setValue(`targetValue${i}`, null);
        setValue(`targetDescription${i}`, null);
        for (let i = 0; i < newArray?.length; i++) {
            setValue(`targetValue${i}`, newArray[i].targetValue);
            setValue(`targetDescription${i}`, newArray[i].targetDescription);
        }
        setTreeData(newArray);
    }

    const handleTreeDataChanges = (event: any, index: number, key: string) => {
        let val = event.target.value;

        if (key === "keyNumber") {
            let isExist = treeData.some((item: any) => (item[key] === event.target.value))
            val = isExist ? (key === "keyNumber" ? null : "") : event.target.value;
        }
        treeData[index][key] = val;
        setValue(`${key}${index}`, val);
        setTreeData([...treeData])
    }

    const validAudioFileType: any = constant.AUDIO_FILE_EXTENSIONS;
    const handleAudiotype = (e: any) => {
        let fileExtension = (e.target.files[0]?.name.split(".").at(-1));
        if (fileExtension !== undefined && !validAudioFileType?.includes(fileExtension)) {
            setFileValidation(true);
            DisplayToaster("bg-danger", `File type is not supported. Files type must be ${validAudioFileType?.join(", ")}`);
            return false;
        } else {
            if (e.target.files[0].size > 20000000) {
                setFileValidation(true);
                DisplayToaster("bg-danger", "Uploaded file size should  be below 20MB.")
                return false;
            } else {
                setFileValidation(false);
                setAudioFileDelete(false);
                setCallTreeAudioFile(URL.createObjectURL(e.target.files[0]));
            }
        }
    }

    const deleteAudioFile = React.useCallback(() => {
        setValue('callTreeAudio', null);
        setCallTreeAudioFile("");
        setAudioFileDelete(true);
    }, []);

    const deletePresentationVideoFile = React.useCallback(() => {
        setValue('presentation', null);
    }, []);

    const deleteKioskHomeScreenLogoFile = React.useCallback(() => {
        setValue('kiosk_home_screen_logo', null);
        setKioskHomeScreenLogo("");
    }, []);

    const handleVoicemailAudio = (e: any) => {
        let fileExtension = (e.target.files[0]?.name.split(".").at(-1));
        if (new RegExp("\\s+").test(e.target?.files[0]?.name)) {
            setFileValidation(true);
            DisplayToaster("bg-danger", "File name should not contain spaces");
            return false;
        }
        if (fileExtension !== undefined && !validAudioFileType?.includes(fileExtension)) {
            setFileValidation(true);
            DisplayToaster("bg-danger", `File type is not supported. Files type must be ${validAudioFileType?.join(", ")}`);
            return false;
        } else {
            if (e.target.files[0].size > 20000000) {
                setFileValidation(true);
                DisplayToaster("bg-danger", "Uploaded file size should  be below 20MB.")
                return false;
            } else {
                setFileValidation(false);
                setVoicemailAudioFileDelete(false);
                setVoicemailAudioFile(URL.createObjectURL(e.target.files[0]));
            }
        }
    }
    const deleteVoicemailAudioFile = React.useCallback(() => {
        setValue('voicemailAudio', null);
        setVoicemailAudioFileDelete(true);
        setFileValidation(false);
    }, []);


    const handleMailAgents = (e: any) => {
        if (e.target.checked) {
            setSendVoiceMailRecording(false);
            setMailToAgents(true);
        } else {
            setMailToAgents(false);
            if (getValues('voiceMailEmail')) {
                setSendVoiceMailRecording(false);
            } else {
                setSendVoiceMailRecording(true);
            }
        }
    }

    const handleVoiceMail = (e: any) => {
        setEnableVoiceMail(e.target.checked);
        setAdditionalEmailAddress("");
        if (e.target.checked) {
            // setMailToAgents(false);
            if (getValues('mailToAgents') || getValues('voiceMailEmail')) {
                setSendVoiceMailRecording(false);
            }
        } else {
            // setMailToAgents(true);
            setSendVoiceMailRecording(true);
        }
    }


    const handleAdditionalEmail = (e: any) => {
        setAdditionalEmailAddress(e.target.value);
        if (e.target.value || getValues('mailToAgents')) {
            setSendVoiceMailRecording(false);
        } else {
            setSendVoiceMailRecording(true);
        }
    }

    const enableDisableEmailToAgentsToggle = () => {
        if (getValues('enableVoiceMail') && (getValues('primary_agent') !== "" || getValues('secondary_agent') !== "")) {
            setHandleEnableDisableEmailToAgentToggle(false);
        } else {
            setHandleEnableDisableEmailToAgentToggle(true);
            setMailToAgents(false);
            setValue('mailToAgents', false);
        }
    }

    const toggleValues = (e: any) => {
        setHummingBirdOrSSM(e.target.checked.toString());
    }

    return (
        <>
            <Container fluid className="conatiner mt-3">
                <TopHeader disable={disable} heading="Create Location" to={constant.LOCATION_LIST} action="List" className="bi bi-list-ul" id="location-list" />
                <Form onSubmit={handleSubmit(handleRegistration)}>
                    <div className='row mb-2'>
                        <div className='col-md-4'>
                            <label>Name <span className='text-danger'>*</span></label>
                        </div>
                        <div className='col-md-4'>
                            <input type="text" defaultValue={searchParams.get('name') ? searchParams.get('name')! : ""} onKeyDown={(e) => restrictIntialSpace(e)} placeholder="My Storage Location" className="form-control" {...register('name', { required: true, minLength: 4, maxLength: 40 })} />
                            {errors.name?.type === "required" && <small className='text-danger' >Name is required</small>}
                            {errors.name?.type === "minLength" && <small className='text-danger' >Minimum 4 characters is required</small>}
                            {errors.name?.type === "maxLength" && <small className='text-danger' >Maximum 40 characters only allowed</small>}

                        </div>
                    </div>
                    <div className='row mb-2'>
                        <div className='col-md-4'>
                            <label>Address <span className='text-danger'>*</span></label>
                        </div>
                        <div className='col-md-4'>
                            <textarea placeholder="123 Main St" defaultValue={searchParams.get('address') ? searchParams.get('address')! : ""} onKeyDown={(e) => restrictIntialSpace(e)} className="form-control"  {...register('address', { required: true, minLength: 4, maxLength: 100 },)} />
                            {errors.address?.type === "required" && <small className='text-danger' >Address is required</small>}
                            {errors.address?.type === "minLength" && <small className='text-danger' >Minimum 4 characters is required</small>}
                            {errors.address?.type === "maxLength" && <small className='text-danger' >Maximum 100 characters is allowed</small>}
                        </div>
                    </div>

                    <div className='row mb-2'>
                        <div className='col-md-4'>
                            <label>City <span className='text-danger'>*</span></label>
                        </div>
                        <div className='col-md-4'>
                            <input type="text" defaultValue={searchParams.get('city') ? searchParams.get('city')! : ""} placeholder="Longview" onKeyDown={(e) => restrictIntialSpace(e)} className="form-control" {...register('city', { required: true, minLength: 2, maxLength: 40 })} />
                            {errors.city?.type === "required" && <small className='text-danger' >City is required</small>}
                            {errors.city?.type === "minLength" && <small className='text-danger' >Minimum 2 characters is required</small>}
                            {errors.city?.type === "maxLength" && <small className='text-danger' >Maximum 40 characters is allowed</small>}
                        </div>
                    </div>

                    <div className='row mb-2'>
                        <div className='col-md-4'>
                            <label>Zip Code <span className='text-danger'>*</span></label>
                        </div>
                        <div className='col-md-4'>
                            <input type="text" defaultValue={searchParams.get('zipCode') ? searchParams.get('zipCode')! : ""} placeholder="523264" onKeyDown={(e) => restrictIntialSpace(e)} className="form-control" {...register('zipCode', {
                                required: true, pattern: {
                                    value: /^\d*$/,
                                    message: 'Zip code field should contain only and numbers',
                                }, minLength: 4, maxLength: 10
                            })} />
                            {errors.zipCode?.type === "required" && <small className='text-danger' >Zip Code is required</small>}
                            {errors.zipCode && errors.zipCode.type === "pattern" && <small className='text-danger' >Zip Code should contain only numbers</small>}
                            {errors.zipCode?.type === "minLength" && <small className='text-danger' >Minimum 4 characters is required</small>}
                            {errors.zipCode?.type === "maxLength" && <small className='text-danger' >Maximum 10 characters is allowed</small>}
                        </div>
                    </div>

                    {/* <div className='row mb-2'>
                        <div className='col-md-4'>
                            <label>State <span className='text-danger'>*</span></label>
                        </div>
                        <div className='col-md-4'>
                            <input type="text" minLength={2} maxLength={40} className="form-control" {...register('state', { required: true, minLength: 4 })} />
                            {errors.state?.type === "required" && <small className='text-danger' >State is required</small>}
                            {errors.state?.type === "minLength" && <small className='text-danger' >Minimum 4 characters is required</small>}
                        </div>
                    </div> */}

                    <div className='row mb-2'>
                        <div className='col-md-4'>
                            <label>State <span className='text-danger'>*</span></label>
                        </div>
                        <div className='col-md-4'>
                            <select className="form-select" {...register('state', { required: true })}>
                                <option value={searchParams.get('state') ? searchParams.get('state')! : ""} hidden>
                                    {searchParams.get('state') ? searchParams.get('state')! : ""}
                                </option>
                                <option value="">Select</option>
                                {Object.values(constant.StatesArray).map((items: any, i: number) => {
                                    return <option key={i} value={items.name}>{items.name}</option>
                                })}
                            </select>
                            {errors.state?.type === "required" && <small className='text-danger' >State is required</small>}
                        </div>
                    </div>

                    <div className="row mb-2">
                        <div className="col-md-4">
                            <label>Time Zone<span className='text-danger'>*</span></label>
                        </div>
                        <div className="col-md-4">
                            <Controller
                                name="timeZone"
                                control={control}
                                defaultValue=""
                                rules={{ required: true }}
                                render={({ field }) => (
                                    <SearchableSelect
                                        options={constant.usTimeZones}
                                        value={field.value}
                                        onChange={field.onChange}
                                        placeholder="Search timezone..."
                                    />
                                )}
                            />
                            {errors?.timeZone?.type === "required" && <small className='text-danger' >Time zone is required</small>}
                        </div>
                    </div>

                    <MultiPMSconnection
                        register={register}
                        errors={errors}
                        hummingBirdOrSSM={hummingBirdOrSSM}
                        pms_name={""}
                        ssm_user_id={""}
                        ssm_password={""}
                        ssm_base_url={""}
                        application_id={""}
                        company_id={""}
                        storageapi_key={""}
                        toggleValues={toggleValues}
                        resetField={resetField}
                        page={"create_location"}
                        setValue={setValue}
                    />

                    <fieldset className="border p-2 col-md-8" style={{ borderRadius: '5px' }}>
                        <legend className="float-none w-auto p-0 m-0">Voicemail</legend>
                        <div className="row mt-0">
                            <div className="col-md-6">Voicemail Option</div>
                            <div className="col-md-6">
                                <div className="form-check form-switch col-md-1 ml-4 cus-toggle">
                                    <input  {...register('enableVoiceMail', { onChange: (e) => { handleVoiceMail(e); enableDisableEmailToAgentsToggle() } })} className="form-check-input" type="checkbox" role="switch" />
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6">
                                <label>Send Voicemail Email Notifications to Agent</label>
                                <strong className="agentEmail"><i className="bi bi-question-circle ml-2" style={{ fontSize: '20px', position: 'relative', top: '2px' }}></i></strong>
                                <div className="tooltip-popup send-voicemail">Enabling this option will forward voicemails to both the primary and secondary agents of that location</div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-check form-switch col-md-1 ml-4 cus-toggle agentEmail">
                                    <input
                                        className="form-check-input" type="checkbox" role="switch" checked={mailToAgents}
                                        {...register('mailToAgents', { onChange: (e) => { handleMailAgents(e) } })} disabled={(handleEnableDisableEmailToAgentToggle === false ? false : true)} />
                                </div>
                                <div className="tooltip-popup send-voicemail-toggle">Please assign Primary or Secondary Agent to enable this option</div>
                            </div>
                        </div>

                        <div className="row mb-2">
                            <div className="col-md-6  p-0 pl-2">
                                <label>Additional Voicemail Email Addresses {(enableVoiceMail && !mailToAgents) ? <span className="text-danger">*</span> : ""}</label>
                                <strong className="agentEmail"><i className="bi bi-question-circle ml-2" style={{ fontSize: '20px', position: 'relative', top: '2px' }}></i></strong>
                                <div className="tooltip-popup additional-voicemail" >Please add the email addresses of the recipients to whom you want to send the voicemails.</div>
                            </div>
                            <div className="col-md-6  pl-2">
                                <input
                                    type="text"
                                    // value={additionalEmailAddress ? additionalEmailAddress : ""}
                                    onKeyDown={(e) => { restrictIntialSpace(e) }}
                                    {...register('voiceMailEmail', {
                                        pattern: {
                                            value: /^[\w\.-]+(?:[\w\.-]+)*@(?:[\w-]+\.)+[a-zA-Z]{2,7}(?:,\s*[\w\.-]+(?:[\w\.-]+)*@(?:[\w-]+\.)+[a-zA-Z]{2,7})*$/,
                                            message: 'Please provide valid email address',
                                        }, onChange: (e) => { handleAdditionalEmail(e) }
                                    })}
                                    className="form-control" readOnly={enableVoiceMail ? false : true} />
                                {errors[`voiceMailEmail`]?.type === "pattern" && <small className='text-danger' >{`Invalid email format`}</small>}
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6">
                                <label className="m-0">Attach Voicemail Recording to Emails </label>
                                <strong className="agentEmail"><i className="bi bi-question-circle ml-2" style={{ fontSize: '20px', position: 'relative', top: '2px' }}></i></strong>
                                <div className="tooltip-popup attach-voicemail">Enabling this option will include Voicemail Recording as attachment in the voicemail notification email.</div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-check form-switch col-md-1 ml-4 cus-toggle">
                                    <input className="form-check-input"
                                        type="checkbox" role="switch"
                                        {...register('sendRecording')}
                                        disabled={sendVoiceMailRecording} />
                                </div>
                            </div>
                        </div>

                        <div className='row mb-2'>
                            <div className='col-md-6 p-0'>
                                <label>Voicemail Audio</label>
                            </div>
                            <div className='col-md-5 p-0' style={{ paddingLeft: '8px !important' }}>
                                <input type="file" accept="audio/*" className="form-control" {...register('voicemailAudio', { required: false, onChange: (e) => { handleVoicemailAudio(e) } })} />
                                <small className="text-primary">Supported formats : {validAudioFileType?.join(", ")} </small><br />
                                <small className="text-primary">{`Please make sure there are no spaces in the file name when uploading.`} </small><br />
                            </div>
                            <div className='col-md-1 p-0 mt-1'>
                                <span onClick={deleteVoicemailAudioFile} ><i className="bi bi-trash text-danger m-1" style={{ fontSize: 24 }}></i></span>
                            </div>
                            <div className='offset-md-6 col-md-5 mt-3 p-0'>
                                <audio src={voicemailAudioFile} controls>
                                    <source src={voicemailAudioFile} />
                                </audio>
                            </div>
                        </div>
                    </fieldset>

                    <div className="row mb-2 mt-4">
                        <div className="col-md-4">
                            Call Tree Creation
                        </div>
                        <div className="row col-md-8" style={{ paddingLeft: '40px' }}>
                            <div className="form-check form-switch col-md-1 cus-toggle">
                                <input onChange={() => { setEnableCallTree(!enableCallTree) }} className="form-check-input" type="checkbox" role="switch" />
                            </div>
                            {enableCallTree &&
                                <div className="col-md-4">
                                    <button type="button" onClick={addRow} className="btn btn-sm btn-primary">Add Row</button>
                                </div>
                            }
                        </div>

                    </div>
                    {
                        enableCallTree && treeData?.length > 0 &&
                        <>
                            <div className='row mb-2 mt-2'>
                                <div className='col-md-4'>
                                    <label>Call Tree Text <span className='text-danger'>*</span></label>
                                </div>
                                <div className='col-md-4'>
                                    <input type="text" defaultValue={callTreeInformationToPlay} onKeyDown={(e) => restrictIntialSpace(e)} placeholder="Please provide Information to play" className="form-control" {...register('callTreeInformationToPlay', { required: getValues('callTreeAudio') === undefined || getValues('callTreeAudio')?.length == 0 || callTreeAudioFile == "" ? true : false, minLength: 4 })} />
                                    {(errors.callTreeInformationToPlay?.type === "required" && callTreeAudioFile?.length <= 0) && <small className='text-danger' >Call Tree Information is required</small>}
                                    {errors.callTreeInformationToPlay?.type === "minLength" && <small className='text-danger' >Minimum 4 characters is required</small>}
                                </div>
                            </div>
                            <div className='row mb-2 mt-2'>
                                <div className='col-md-4'>
                                    <label> Call Tree Audio</label>
                                </div>
                                <div className="col-md-4">
                                    <div className="d-flex align-center">
                                        <input type="file" accept="audio/*" className="form-control"
                                            {...register('callTreeAudio', { required: (getValues('callTreeInformationToPlay') == "" ? true : false), onChange: (e) => { handleAudiotype(e) } })} />
                                        {/* <div style={{ position: 'absolute', right: '-10px', top: '5px' }}>
                                            <div data-toggle="tooltip" title={`Please make sure there are no spaces in the file name when uploading. supported file types are ${validAudioFileType.join(',')}`}><i className="bi bi-info-circle"></i></div>
                                        </div> */}
                                    </div>
                                    <small className="text-primary">Supported formats : {validAudioFileType?.join(", ")} </small><br />
                                    <small className="text-primary">{`Please make sure there are no spaces in the file name when uploading.`} </small><br />
                                    {errors.callTreeAudio && <small className='text-danger' > Call Tree Audio is required</small>}<br />
                                    <audio src={audioFileDelete && callTreeAudioFile == "" ? "" : callTreeAudioFile} controls>
                                        <source src={audioFileDelete && callTreeAudioFile == "" ? "" : callTreeAudioFile} />
                                    </audio>
                                </div>
                                <div className='col-md-1 p-0 mt-1'>
                                    <span onClick={deleteAudioFile} ><i className="bi bi-trash text-danger m-1" style={{ fontSize: 24 }}></i></span>
                                </div>
                            </div>
                            <div className='row mb-2 mt-2'>
                                <div className="pl-4 col-3 col-md-4">
                                    <label><b>Key number</b> </label>
                                </div>

                                <div className="col col-md-4">
                                    <div className="row">
                                        <div className="col-4 col-md-4 form-check">
                                            <b>Action</b>
                                        </div>

                                        <div className="col-4 col-md-4 form-check">
                                            <b>Description</b>
                                        </div>

                                        <div className="col-4 col-md-4">
                                            <b>target</b>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>

                    }
                    {
                        enableCallTree && treeData.map((item: any, i: number) => (

                            <div className='row mb-2 mt-2' key={i}>
                                <div className="pl-1 pb-2  col-md-4">
                                    <div className="col-md-4">
                                        <input type="number" {...register(`keyNumber${i}`, {
                                            required: true, min: 0, max: 9, pattern: {
                                                value: /^[0-9]+$/,
                                                message: 'Name field should contain only alphabets',
                                            }, onChange: (e) => { handleTreeDataChanges(e, i, 'keyNumber') }
                                        })} value={item.keyNumber} className="form-control" />
                                    </div>
                                    {errors[`keyNumber${i}`]?.type === "required" && <small className='text-danger' >{`Key Number ${i + 1} required`}</small>}
                                    {errors[`keyNumber${i}`]?.type === "pattern" && <small className='text-danger' >{`please enter Key Number ${i + 1} value below 9`}</small>}
                                    {errors[`keyNumber${i}`]?.type === "max" && <small className='text-danger' >{`please enter Key Number ${i + 1} value below 9`}</small>}
                                    {errors[`keyNumber${i}`]?.type === "min" && <small className='text-danger' >{`please enter Key Number ${i + 1} value below 9`}</small>}
                                </div>

                                <div className="col col-md-5">
                                    <div className="row">
                                        <div className="col-3 col-md-3 form-check">
                                            <select value={item.TargetType} {...register(`targetType${i}`, { required: true, onChange: (e) => { handleTreeDataChanges(e, i, 'targetType') } })} className="form-control">
                                                <option value="">Select</option>
                                                <option value="phoneNum" >Phone Number</option>
                                                <option value="location">Location</option>
                                            </select>
                                            {errors[`targetType${i}`]?.type === "required" && <small className='text-danger' >{`Action ${i + 1} required`}</small>}
                                        </div>

                                        <div className="col-3 col-md-3 form-check">
                                            <input type="text" className="form-control" {...register(`targetDescription${i}`, {
                                                required: (getValues(`targetType${i}`) === "phoneNum" ? true : false), onChange: (e) => { handleTreeDataChanges(e, i, 'targetDescription') }
                                            })} />
                                            {errors[`targetDescription${i}`]?.type === "required" && <small className='text-danger' >{`Description ${i + 1} required`}</small>}
                                        </div>

                                        <div className="col-3 col-md-3">
                                            {
                                                treeData[i].targetType === "location" ?

                                                    <select value={treeData[i].targetValue} {...register(`targetValue${i}`, { required: true, onChange: (e) => { handleTreeDataChanges(e, i, 'targetValue') } })} className="form-control">
                                                        <option>Select</option>
                                                        {agentMappedLocationDetails?.map((item, index) => (
                                                            <option value={item?.id + "," + item.name} key={index} disabled={checkDisbale(item?.id, treeData)} >{item.name}</option>
                                                        ))}
                                                    </select>

                                                    : <InputMask placeholder="(123)-456-7890"
                                                        mask="(999)-999-99999" maskChar={null} type="text" {...register(`targetValue${i}`, { required: true, onChange: (e) => { handleTreeDataChanges(e, i, 'targetValue') } })} value={item?.targetValue} className="form-control" />
                                            }
                                            {errors[`targetValue${i}`]?.type === "required" && <small className='text-danger' >{`target ${i + 1} required`}</small>}

                                        </div>
                                        <div className="col-2 col-md-2">
                                            <span onClick={(e) => { removeField(e, i) }} ><i className="bi bi-trash text-danger m-1" style={{ fontSize: 24 }}></i></span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        ))
                    }

                    <BusinessHoursCollapsible
                        register={register}
                        errors={errors}
                        scheduleData={timeOffDetails}
                        onScheduleChange={(day, field, value) => {
                            if (field === 'holiday') {
                                setTimeOffDetails((prevState: any) => ({
                                    days: {
                                        ...prevState.days,
                                        [day]: {
                                            ...prevState.days[day],
                                            holiday: value as boolean,
                                            time: value ? '' : prevState.days[day].time
                                        }
                                    }
                                }));
                            } else {
                                setTimeOffDetails((prevState: any) => ({
                                    days: {
                                        ...prevState.days,
                                        [day]: {
                                            ...prevState.days[day],
                                            time: value as string
                                        }
                                    }
                                }));
                            }
                        }}
                        title="Kiosk Active Hours"
                        fieldPrefix="kiosk_"
                    />

                    <BusinessHoursCollapsible
                        register={register}
                        errors={errors}
                        scheduleData={callForwardActiveHrs}
                        onScheduleChange={(day, field, value) => {
                            if (field === 'holiday') {
                                setCallForwardActiveHrs((prevState: any) => ({
                                    days: {
                                        ...prevState.days,
                                        [day]: {
                                            ...prevState.days[day],
                                            holiday: value as boolean,
                                            time: value ? '' : prevState.days[day].time
                                        }
                                    }
                                }));
                            } else {
                                setCallForwardActiveHrs((prevState: any) => ({
                                    days: {
                                        ...prevState.days,
                                        [day]: {
                                            ...prevState.days[day],
                                            time: value as string
                                        }
                                    }
                                }));
                            }
                        }}
                        title="Call Center Active Hours"
                        fieldPrefix="callForward_"
                    />

                    <div className='row mb-2'>
                        <div className='col-md-4'>
                            <label>Twilio Number </label>
                        </div>
                        <div className='col-md-4'>
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <div className="input-group-text" id="btnGroupAddon"><b>+1</b></div>
                                </div>
                                <InputMask
                                    value={contact}
                                    className="form-control"
                                    placeholder="(123)-456-7890"
                                    mask="(999)-999-99999" maskChar={null}
                                    {...register('contact', { required: (enableCallTree ? true : false), minLength: 14, maxLength: 15, onChange: (e) => { mobileCheck(e) } })}
                                />
                            </div>
                            {errors.contact?.type === "required" && <small className='text-danger' >Twilio Number is required</small>}
                            {errors.contact?.type === "minLength" && <small className='text-danger' >Minimum 10 numbers is required</small>}
                            {errors.contact?.type === "maxLength" && <small className='text-danger' >Maximum 11 numbers is allowed</small>}
                        </div>
                    </div>

                    {   //  Removed this condition since we are implementing call center active hours,
                        // So irrespective of voicemail enabled or not if call comes outside of business hours we should forward it.
                        // !enableVoiceMail &&
                        <div className='row mb-2'>
                            <div className='col-md-4'>
                                <label>Agent Unavailable Forwarding Number</label>
                            </div>
                            <div className='col-md-4'>
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <div className="input-group-text" id="btnGroupAddon"><b>+1</b></div>
                                    </div>
                                    <InputMask
                                        value={callForwardContact}
                                        className="form-control"
                                        placeholder="(123)-456-7890"
                                        aria-describedby="btnGroupAddon"
                                        mask="(999)-999-99999"
                                        maskChar={null}
                                        {...register('call_forward', { minLength: 14, maxLength: 15, onChange: (e) => { call_forward_check(e); setAgentForwardingNumber(RevertFormattedPhoneNumber(e.target.value)) } })}
                                    />
                                </div>
                                {(agentForwardingNumber && errors.call_forward?.type === "minLength") && <small className='text-danger' >Minimum 10 numbers is required</small>}
                                {(agentForwardingNumber && errors.call_forward?.type === "maxLength") && <small className='text-danger' >Maximum 11 numbers is allowed</small>}
                            </div>
                        </div>
                    }
                    <div className='row mb-2'>
                        <div className='col-md-4'>
                            <label>Customer Facing Phone Number</label>
                        </div>
                        <div className='col-md-4'>
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <div className="input-group-text" id="btnGroupAddon"><b>+1</b></div>
                                </div>
                                <InputMask
                                    value={customerContact}
                                    className="form-control"
                                    placeholder="(123)-456-7890"
                                    aria-describedby="btnGroupAddon"
                                    mask="(999)-999-99999"
                                    maskChar={null}
                                    {...register('customer_contact', { minLength: 14, maxLength: 15, onChange: (e) => { call_forward_check(e); setCustomerFacingNumber(RevertFormattedPhoneNumber(e.target.value)) } })}
                                />
                            </div>
                            {(customerFacingNumber && errors.customer_contact?.type === "minLength") && <small className='text-danger' >Minimum 10 numbers is required</small>}
                            {(customerFacingNumber && errors.customer_contact?.type === "maxLength") && <small className='text-danger' >Maximum 11 numbers is allowed</small>}
                        </div>
                    </div>

                    <div className='row mb-2'>
                        <div className='col-md-4'>
                            <label>Primary Agent </label>
                        </div>
                        <div className='col-md-4'>
                            <select className="form-select" {...register('primary_agent', { required: false, onChange: (e) => { handleChange(e); enableDisableEmailToAgentsToggle() } })}>
                                <option value="">Select</option>
                                {Object.values(resultData).map((items: any, i: number) => {
                                    return <option key={items._id} value={items._id}>{items.name} - {items.email}</option>
                                })}
                            </select>
                            {errors.primary_agent && <small className='text-danger' >Primary Agent is required</small>}
                        </div>
                    </div>

                    <div className='row mb-2'>
                        <div className='col-md-4'>
                            <label>Secondary Agent </label>
                        </div>
                        <div className='col-md-4'>
                            <select className="form-select" {...register('secondary_agent', { required: false, onChange: (e) => { handleChange(e); enableDisableEmailToAgentsToggle() } })}>
                                <option value="">Select</option>
                                {Object.values(resultData).map((items: any, i: number) => {
                                    return <option key={items._id} value={items._id}>{items.name} - {items.email}</option>
                                })}
                            </select>
                            {/* {errors.secondary_agent && <small className='text-danger' >Secondary Agent is required</small>} */}
                        </div>
                    </div>

                    <div className='row mb-2'>
                        <div className='col-md-4'>
                            <label>Presentation Video </label>
                        </div>
                        <div className='col-md-4'>
                            <input type="file" accept="video/*" className="form-control" {...register('presentation', { required: false, onChange: (e) => { handleVideotype(e) } })} />
                            <small className="text-primary">Supported formats : {allowedExtensionTypes.join(", ")} </small><br />
                            {errors.presentation && <small className='text-danger' > Presentation is required</small>}
                        </div>
                        <div className='col-md-1 p-0 mt-1'>
                            <span onClick={deletePresentationVideoFile} ><i className="bi bi-trash text-danger m-1" style={{ fontSize: 24 }}></i></span>
                        </div>
                    </div>

                    <div className='row mb-2'>
                        <div className='col-md-4'>
                            <label>Kiosk Footer</label>
                        </div>
                        <div className='col-md-4'>
                            <input type="file" id="fileInput" accept='image/*' className="form-control" {...register('kiosk_advertisement', { onChange: (e) => { handleImageType(e) } })} />
                            <small className="text-primary">Supported formats : {allowedImageExtensionTypes.join(", ")} </small><br />
                            {
                                footerImage &&
                                <img
                                    alt=""
                                    src={footerImage}
                                    width="70%"
                                    height="auto"
                                    className="d-inline-block mt-3 mb-2"
                                />
                            }
                        </div>
                    </div>

                    <div className='row mb-2'>
                        <div className='col-md-4'>
                            <label>Kiosk Background Color</label>
                        </div>
                        <div className='col-md-4'>
                            <CompactPicker color={backGroundColor} onChangeComplete={handleColorPickerChange} />
                        </div>
                    </div>

                    <div className='row mb-2'>
                        <div className='col-md-4'>
                            <label>Kiosk Home Screen Logo </label>
                        </div>
                        <div className='col-md-4'>
                            <input type="file" accept="image/*" className="form-control" {...register('kiosk_home_screen_logo', { onChange: (e) => { handleImageType(e, 'kiosk_home_screen_logo') } })} />
                            <small className="text-primary">Supported formats : {allowedImageExtensionTypes.join(", ")} </small><br />
                            {
                                kioskHomeScreenLogo &&
                                <img
                                    alt=""
                                    src={kioskHomeScreenLogo}
                                    width="70%"
                                    height="auto"
                                    className="d-inline-block mt-3 mb-2"
                                />
                            }
                        </div>
                        <div className='col-md-1 p-0 mt-1'>
                            <span onClick={deleteKioskHomeScreenLogoFile} ><i className="bi bi-trash text-danger m-1" style={{ fontSize: 24 }}></i></span>
                        </div>
                    </div>

                    <div className='text-center'>
                        <button type="submit" disabled={disable || agentCheck || fileValidation} className='btn btn-primary app-button-color'>{isLoading &&
                            <span className="spinner-border text-white mr-1" style={{ width: '18px', height: "18px" }} role="status"></span>
                        }{" "} Submit</button>
                        {disable ? <Link to={constant.LOCATION_LIST} className="disabledCursor" onClick={(event) => event.preventDefault()}><button type="button" disabled={disable} className='btn btn-secondary m-2'>Cancel</button></Link> : <Link to={constant.LOCATION_LIST}><button type="button" className='btn btn-secondary m-2'>Cancel</button></Link>}
                    </div>
                </Form>
            </Container >
        </>
    )
}

export default CreateLocation;